import { __ } from '@wordpress/i18n'
import React, { useState, useEffect, useRef } from 'react'
import PropTypes from 'prop-types'
import apiFetch from '@wordpress/api-fetch'
import ReactSelect from 'react-select'
import ReactPaginate from 'react-paginate'
import InsightTeaser from '../InsightTeaser'
import { Row } from 'scripts/styled-components'
import { Wrapper, Filter, Label } from './custom.styled'

const InsightsGallery = ({ isEditor }) => {
  const [data, setData] = useState([])
  const [pageCount, setPageCount] = useState(0)
  const [currentPage, setCurrentPage] = useState(1)
  const perPage = 12
  const WrapperRef = useRef()
  const [indicators, setIndicators] = useState([])
  const [indicator, setIndicator] = useState(0)
  const [publishers, setPublishers] = useState([])
  const [publisher, setPublisher] = useState(0)
  const [date, setDate] = useState('all')

  const dateOptions = [
    { label: 'All Release Dates', value: 'all' },
    { label: 'Last week', value: '-1 week' },
    { label: 'Last month', value: '-1 month' },
    { label: 'Last year', value: '-1 year' },
  ]

  useEffect(() => {
    apiFetch({
      path: `/wp/v2/insight_category?per_page=100`,
    }).then(categories => {
      let newOptions = [
        {
          value: 0,
          label: __('All Indicators', 'dhsv_blocks'),
        },
      ]
      categories.forEach(category => {
        newOptions.push({
          value: category.id,
          label: category.name.replace(/&amp;/g, '&'),
        })
      })
      setIndicators(newOptions)
    })

    apiFetch({
      path: `/wp/v2/insight_publisher?per_page=100`,
    }).then(categories => {
      let newOptions = [
        {
          value: 0,
          label: __('All Publishers', 'dhsv_blocks'),
        },
      ]
      categories.forEach(category => {
        newOptions.push({
          value: category.id,
          label: category.name.replace(/&amp;/g, '&'),
        })
      })
      setPublishers(newOptions)
    })
  }, [])

  useEffect(() => {
    setCurrentPage(1)
  }, [indicator, publisher, date])

  useEffect(() => {
    loadData()
  }, [indicator, publisher, date, currentPage])

  useEffect(() => {
    if (data.length) {
      WrapperRef.current.scrollIntoView({ behavior: 'smooth' })
    }
  }, [currentPage])

  const loadData = () => {
    const params = {
      postType: 'insight',
      page: currentPage,
      count: currentPage ? perPage : '-1',
    }

    if (indicator !== 0 && indicator) {
      params.insight_category = indicator
    }

    if (publisher !== 0 && publisher) {
      params.insight_publisher = publisher
    }

    if (date !== 'all' && date) {
      params.date_after = date
    }

    let url_params = '/'
    if (params) {
      let i = 0
      for (const [key, value] of Object.entries(params)) {
        url_params += (i === 0 ? '?' : '&') + key + '=' + value
        i++
      }
    }

    apiFetch({
      path: `/dhsv/v1/query${url_params}`,
    })
      .then(({ posts, query }) => {
        setData(posts)
        setPageCount(query.max_num_pages)
      })
      .catch(error => {
        if (process.env.NODE_ENV === 'development') {
          console.error(error) //eslint-disable-line
        }
      })
  }

  const handlePageClick = data => {
    setCurrentPage(data ? data.selected + 1 : false)
  }

  return (
    <Wrapper id="insights-grid" ref={WrapperRef}>
      <Filter>
        <Label>{__('Filter Options:', 'dhsv_theme')}</Label>
        {indicators.length > 0 ? (
          <ReactSelect
            className="select-stylized"
            classNamePrefix="select"
            placeholder="All Indicators"
            value={indicators.map(option =>
              option.value == indicator ? option : false
            )}
            defaultValue={indicator}
            onChange={selected => selected && setIndicator(selected.value)}
            options={indicators}
          />
        ) : (
          <span>{__('Loading Indicators...', 'dhsv_theme')}</span>
        )}
        {publishers.length > 0 ? (
          <ReactSelect
            className="select-stylized"
            classNamePrefix="select"
            placeholder="All Publishers"
            value={publishers.map(option =>
              option.value == publisher ? option : false
            )}
            defaultValue={publisher}
            onChange={selected => selected && setPublisher(selected.value)}
            options={publishers}
          />
        ) : (
          <span>{__('Loading Publishers...', 'dhsv_theme')}</span>
        )}
        <ReactSelect
          className="select-stylized"
          classNamePrefix="select"
          placeholder="All Release Dates"
          value={dateOptions.map(option =>
            option.value == date ? option : false
          )}
          defaultValue={date}
          onChange={selected => selected && setDate(selected.value)}
          options={dateOptions}
        />
      </Filter>
      <Row mobileDirection={'wrap'} direction={'wrap'} gap={'20px'}>
        {data.length > 0 &&
          data.map((item, key) => (
            <InsightTeaser key={key} post={item} isEditor={isEditor} />
          ))}
      </Row>
      {pageCount > 1 && currentPage && (
        <ReactPaginate
          pageCount={pageCount}
          onPageChange={handlePageClick}
          containerClassName="pagination"
          pageClassName="pagination__item"
          previousClassName="pagination__item pagination__item--arrow"
          nextClassName="pagination__item pagination__item--arrow"
          pageLinkClassName="pagination__link"
          previousLinkClassName="pagination__link"
          nextLinkClassName="pagination__link"
          previousLabel={<i className="las la-angle-left"></i>}
          nextLabel={<i className="las la-angle-right"></i>}
          hrefBuilder={() => '#insights-grid'}
        />
      )}
    </Wrapper>
  )
}

InsightsGallery.propTypes = {
  isEditor: PropTypes.bool,
}

export default InsightsGallery
